import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Impactschology() {
  return (
    <section className="solutions-schology impact-schology p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2 style={{ color: "#111322" }}>
              Innovative Solutions: How TekRevol Crafted the{" "}
              <span className="text-rise-yellow">Rise Up Kings </span>
              Experience
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              TekRevol developed Rise Up Kings with a focus on usability,
              scalability, and community engagement. By integrating robust
              features like personal goal tracking, community messaging, and
              content libraries, we delivered a platform that aligned with the
              client’s vision.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
            <div className="sol-box" style={{ background: "#232323" }}>
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  fill="none"
                  viewBox="0 0 41 41"
                >
                  <g fill="#D6B156" clipPath="url(#clip0_449_8460)">
                    <path d="M20.476 40.15a19.97 19.97 0 0 1-13.77-5.35A20.015 20.015 0 0 1 4.931 7.38 19.97 19.97 0 0 1 17.896.295Q19.096.16 20.3.179a1.567 1.567 0 0 1 1.73 1.467 1.616 1.616 0 0 1-1.54 1.717 33 33 0 0 0-3.4.352 16.8 16.8 0 0 0-8.07 4.143 16.863 16.863 0 0 0-.133 24.602 16.82 16.82 0 0 0 17.078 3.675 16.83 16.83 0 0 0 7.45-5.178 16.86 16.86 0 0 0 3.683-8.299c.117-.807.073-1.6.16-2.406a1.616 1.616 0 0 1 1.43-1.562 1.57 1.57 0 0 1 1.752 1.694 17.95 17.95 0 0 1-1.613 7.792 19.9 19.9 0 0 1-6.583 8.298 19.85 19.85 0 0 1-9.906 3.734 16 16 0 0 1-1.862-.059"></path>
                    <path d="M11.55 16.056a1.67 1.67 0 0 1 1.304.675c1.891 2.069 3.797 4.108 5.673 6.207.469.528.718.484 1.202 0q8.399-8.452 16.826-16.86.35-.367.762-.66a1.465 1.465 0 0 1 1.994.205 1.47 1.47 0 0 1 .102 2.054q-.246.302-.527.572L20.608 26.518c-1.216 1.218-1.979 1.218-3.137 0-2.345-2.538-4.675-5.092-7.006-7.63a1.63 1.63 0 0 1-.396-1.923 1.47 1.47 0 0 1 1.48-.91"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_449_8460">
                      <path fill="#fff" d="M.44.164h40v40h-40z"></path>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h5 style={{ color: "#fff" }}>100+ schools onboarded</h5>
              <p style={{ color: "#fff" }}>
                Schology has successfully onboarded over 100 schools, making it
                a go-to platform for educational resource management and
                communication
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
            <div className="sol-box" style={{ background: "#232323" }}>
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  fill="none"
                  viewBox="0 0 41 41"
                >
                  <g fill="#D6B156" clipPath="url(#clip0_449_8460)">
                    <path d="M20.476 40.15a19.97 19.97 0 0 1-13.77-5.35A20.015 20.015 0 0 1 4.931 7.38 19.97 19.97 0 0 1 17.896.295Q19.096.16 20.3.179a1.567 1.567 0 0 1 1.73 1.467 1.616 1.616 0 0 1-1.54 1.717 33 33 0 0 0-3.4.352 16.8 16.8 0 0 0-8.07 4.143 16.863 16.863 0 0 0-.133 24.602 16.82 16.82 0 0 0 17.078 3.675 16.83 16.83 0 0 0 7.45-5.178 16.86 16.86 0 0 0 3.683-8.299c.117-.807.073-1.6.16-2.406a1.616 1.616 0 0 1 1.43-1.562 1.57 1.57 0 0 1 1.752 1.694 17.95 17.95 0 0 1-1.613 7.792 19.9 19.9 0 0 1-6.583 8.298 19.85 19.85 0 0 1-9.906 3.734 16 16 0 0 1-1.862-.059"></path>
                    <path d="M11.55 16.056a1.67 1.67 0 0 1 1.304.675c1.891 2.069 3.797 4.108 5.673 6.207.469.528.718.484 1.202 0q8.399-8.452 16.826-16.86.35-.367.762-.66a1.465 1.465 0 0 1 1.994.205 1.47 1.47 0 0 1 .102 2.054q-.246.302-.527.572L20.608 26.518c-1.216 1.218-1.979 1.218-3.137 0-2.345-2.538-4.675-5.092-7.006-7.63a1.63 1.63 0 0 1-.396-1.923 1.47 1.47 0 0 1 1.48-.91"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_449_8460">
                      <path fill="#fff" d="M.44.164h40v40h-40z"></path>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h5 style={{ color: "#fff" }}>Gamification</h5>
              <p style={{ color: "#fff" }}>
                Features like ranks, badges, and streaks incentivized users,
                encouraging consistent engagement and friendly competition.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4">
            <div className="sol-box" style={{ background: "#232323" }}>
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  fill="none"
                  viewBox="0 0 41 41"
                >
                  <g fill="#D6B156" clipPath="url(#clip0_449_8460)">
                    <path d="M20.476 40.15a19.97 19.97 0 0 1-13.77-5.35A20.015 20.015 0 0 1 4.931 7.38 19.97 19.97 0 0 1 17.896.295Q19.096.16 20.3.179a1.567 1.567 0 0 1 1.73 1.467 1.616 1.616 0 0 1-1.54 1.717 33 33 0 0 0-3.4.352 16.8 16.8 0 0 0-8.07 4.143 16.863 16.863 0 0 0-.133 24.602 16.82 16.82 0 0 0 17.078 3.675 16.83 16.83 0 0 0 7.45-5.178 16.86 16.86 0 0 0 3.683-8.299c.117-.807.073-1.6.16-2.406a1.616 1.616 0 0 1 1.43-1.562 1.57 1.57 0 0 1 1.752 1.694 17.95 17.95 0 0 1-1.613 7.792 19.9 19.9 0 0 1-6.583 8.298 19.85 19.85 0 0 1-9.906 3.734 16 16 0 0 1-1.862-.059"></path>
                    <path d="M11.55 16.056a1.67 1.67 0 0 1 1.304.675c1.891 2.069 3.797 4.108 5.673 6.207.469.528.718.484 1.202 0q8.399-8.452 16.826-16.86.35-.367.762-.66a1.465 1.465 0 0 1 1.994.205 1.47 1.47 0 0 1 .102 2.054q-.246.302-.527.572L20.608 26.518c-1.216 1.218-1.979 1.218-3.137 0-2.345-2.538-4.675-5.092-7.006-7.63a1.63 1.63 0 0 1-.396-1.923 1.47 1.47 0 0 1 1.48-.91"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_449_8460">
                      <path fill="#fff" d="M.44.164h40v40h-40z"></path>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h5 style={{ color: "#fff" }}>Progress Tracking</h5>
              <p style={{ color: "#fff" }}>
                Each user could track their achievements in personal development
                areas like fitness, faith, and finance, providing both
                motivation and measurable growth.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 mb-lg-0">
            <div className="sol-box" style={{ background: "#232323" }}>
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  fill="none"
                  viewBox="0 0 41 41"
                >
                  <g fill="#D6B156" clipPath="url(#clip0_449_8460)">
                    <path d="M20.476 40.15a19.97 19.97 0 0 1-13.77-5.35A20.015 20.015 0 0 1 4.931 7.38 19.97 19.97 0 0 1 17.896.295Q19.096.16 20.3.179a1.567 1.567 0 0 1 1.73 1.467 1.616 1.616 0 0 1-1.54 1.717 33 33 0 0 0-3.4.352 16.8 16.8 0 0 0-8.07 4.143 16.863 16.863 0 0 0-.133 24.602 16.82 16.82 0 0 0 17.078 3.675 16.83 16.83 0 0 0 7.45-5.178 16.86 16.86 0 0 0 3.683-8.299c.117-.807.073-1.6.16-2.406a1.616 1.616 0 0 1 1.43-1.562 1.57 1.57 0 0 1 1.752 1.694 17.95 17.95 0 0 1-1.613 7.792 19.9 19.9 0 0 1-6.583 8.298 19.85 19.85 0 0 1-9.906 3.734 16 16 0 0 1-1.862-.059"></path>
                    <path d="M11.55 16.056a1.67 1.67 0 0 1 1.304.675c1.891 2.069 3.797 4.108 5.673 6.207.469.528.718.484 1.202 0q8.399-8.452 16.826-16.86.35-.367.762-.66a1.465 1.465 0 0 1 1.994.205 1.47 1.47 0 0 1 .102 2.054q-.246.302-.527.572L20.608 26.518c-1.216 1.218-1.979 1.218-3.137 0-2.345-2.538-4.675-5.092-7.006-7.63a1.63 1.63 0 0 1-.396-1.923 1.47 1.47 0 0 1 1.48-.91"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_449_8460">
                      <path fill="#fff" d="M.44.164h40v40h-40z"></path>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h5 style={{ color: "#fff" }}>Communication Tools</h5>
              <p style={{ color: "#fff" }}>
                We developed a chat module with both individual and group chat
                features, allowing users to communicate and build connections
                within the platform.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 mb-md-0">
            <div className="sol-box" style={{ background: "#232323" }}>
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  fill="none"
                  viewBox="0 0 41 41"
                >
                  <g fill="#D6B156" clipPath="url(#clip0_449_8460)">
                    <path d="M20.476 40.15a19.97 19.97 0 0 1-13.77-5.35A20.015 20.015 0 0 1 4.931 7.38 19.97 19.97 0 0 1 17.896.295Q19.096.16 20.3.179a1.567 1.567 0 0 1 1.73 1.467 1.616 1.616 0 0 1-1.54 1.717 33 33 0 0 0-3.4.352 16.8 16.8 0 0 0-8.07 4.143 16.863 16.863 0 0 0-.133 24.602 16.82 16.82 0 0 0 17.078 3.675 16.83 16.83 0 0 0 7.45-5.178 16.86 16.86 0 0 0 3.683-8.299c.117-.807.073-1.6.16-2.406a1.616 1.616 0 0 1 1.43-1.562 1.57 1.57 0 0 1 1.752 1.694 17.95 17.95 0 0 1-1.613 7.792 19.9 19.9 0 0 1-6.583 8.298 19.85 19.85 0 0 1-9.906 3.734 16 16 0 0 1-1.862-.059"></path>
                    <path d="M11.55 16.056a1.67 1.67 0 0 1 1.304.675c1.891 2.069 3.797 4.108 5.673 6.207.469.528.718.484 1.202 0q8.399-8.452 16.826-16.86.35-.367.762-.66a1.465 1.465 0 0 1 1.994.205 1.47 1.47 0 0 1 .102 2.054q-.246.302-.527.572L20.608 26.518c-1.216 1.218-1.979 1.218-3.137 0-2.345-2.538-4.675-5.092-7.006-7.63a1.63 1.63 0 0 1-.396-1.923 1.47 1.47 0 0 1 1.48-.91"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_449_8460">
                      <path fill="#fff" d="M.44.164h40v40h-40z"></path>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h5 style={{ color: "#fff" }}>Content Library</h5>
              <p style={{ color: "#fff" }}>
                The Vault feature was integrated to provide access to podcasts,
                masterminds, and onboarding resources, with downloadable content
                available for offline use.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="sol-box" style={{ background: "#232323" }}>
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  fill="none"
                  viewBox="0 0 41 41"
                >
                  <g fill="#D6B156" clipPath="url(#clip0_449_8460)">
                    <path d="M20.476 40.15a19.97 19.97 0 0 1-13.77-5.35A20.015 20.015 0 0 1 4.931 7.38 19.97 19.97 0 0 1 17.896.295Q19.096.16 20.3.179a1.567 1.567 0 0 1 1.73 1.467 1.616 1.616 0 0 1-1.54 1.717 33 33 0 0 0-3.4.352 16.8 16.8 0 0 0-8.07 4.143 16.863 16.863 0 0 0-.133 24.602 16.82 16.82 0 0 0 17.078 3.675 16.83 16.83 0 0 0 7.45-5.178 16.86 16.86 0 0 0 3.683-8.299c.117-.807.073-1.6.16-2.406a1.616 1.616 0 0 1 1.43-1.562 1.57 1.57 0 0 1 1.752 1.694 17.95 17.95 0 0 1-1.613 7.792 19.9 19.9 0 0 1-6.583 8.298 19.85 19.85 0 0 1-9.906 3.734 16 16 0 0 1-1.862-.059"></path>
                    <path d="M11.55 16.056a1.67 1.67 0 0 1 1.304.675c1.891 2.069 3.797 4.108 5.673 6.207.469.528.718.484 1.202 0q8.399-8.452 16.826-16.86.35-.367.762-.66a1.465 1.465 0 0 1 1.994.205 1.47 1.47 0 0 1 .102 2.054q-.246.302-.527.572L20.608 26.518c-1.216 1.218-1.979 1.218-3.137 0-2.345-2.538-4.675-5.092-7.006-7.63a1.63 1.63 0 0 1-.396-1.923 1.47 1.47 0 0 1 1.48-.91"></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_449_8460">
                      <path fill="#fff" d="M.44.164h40v40h-40z"></path>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <h5 style={{ color: "#fff" }}>Payment & Subscription</h5>
              <p style={{ color: "#fff" }}>
                We implemented tiered subscription models, allowing paid users
                access to premium content and advanced features, all handled
                through secure
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Impactschology;
